var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container", attrs: { id: "goods-edit" } },
    [
      _c("breadcrumb-top", {
        attrs: { breadcrumbConfig: _vm.dataList, isBack: "1" },
      }),
      _c(
        "div",
        { staticClass: "content c-top" },
        [
          _c("breadcrumb-search", {
            attrs: { breadcrumbSearch: _vm.searchList },
          }),
          _c(
            "el-form",
            { attrs: { inline: true, "label-width": "", size: "small" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "模板名称" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入模板名称",
                      clearable: "",
                      maxlength: 20,
                    },
                    model: {
                      value: _vm.searchForm.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "name", $$v)
                      },
                      expression: "searchForm.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.getList()
                        },
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.getList()
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { plain: "", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.reset()
                        },
                      },
                    },
                    [_vm._v("重置")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "padding-bottom": "20px" } },
            _vm._l(_vm.tableData, function (item, index) {
              return _c(
                "el-card",
                {
                  key: index,
                  staticClass: "box-card",
                  staticStyle: {
                    "margin-bottom": "20px",
                    "box-shadow": "none",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between",
                      },
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [
                      _c("div", { staticClass: "title" }, [
                        _vm._v(_vm._s(item.name)),
                      ]),
                      _c(
                        "div",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.add(item.id)
                                },
                              },
                            },
                            [_vm._v("查看")]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    [
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            data: item.list,
                            "header-cell-style": {
                              textAlign: "left",
                              background: "#F5F6FA",
                              color: "#303033",
                            },
                            "row-style": { height: "70px", textAlign: "left" },
                          },
                        },
                        [
                          _c(
                            "el-table-column",
                            { attrs: { prop: "date", label: "运送方式" } },
                            [
                              _c("template", { slot: "header" }, [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "text-align": "left",
                                      "margin-left": "36px",
                                    },
                                  },
                                  [_vm._v(" 运送方式 ")]
                                ),
                              ]),
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "text-align": "left",
                                      "margin-left": "36px",
                                    },
                                  },
                                  [_vm._v("快递")]
                                ),
                              ],
                            ],
                            2
                          ),
                          _c(
                            "el-table-column",
                            {
                              attrs: { prop: "address", label: "运送到" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        scope.row.address == "全部地区"
                                          ? _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  "text-align": "left",
                                                },
                                              },
                                              [_vm._v(" 全部地区 ")]
                                            )
                                          : _c(
                                              "div",
                                              [
                                                _c(
                                                  "el-tooltip",
                                                  {
                                                    attrs: {
                                                      "popper-class":
                                                        "atooltip",
                                                      effect: "dark",
                                                      content:
                                                        scope.row.address,
                                                      placement: "bottom-start",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          "text-align": "left",
                                                          width: "150px",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " 地区（查看区域） "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _c("template", { slot: "header" }, [
                                _c(
                                  "div",
                                  { staticStyle: { "text-align": "left" } },
                                  [_vm._v("运送到")]
                                ),
                              ]),
                            ],
                            2
                          ),
                          _c(
                            "el-table-column",
                            {
                              attrs: { prop: "firstNum" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "text-align": "left",
                                            },
                                          },
                                          [_vm._v(_vm._s(scope.row.firstNum))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _c("template", { slot: "header" }, [
                                item.list && item.list[0].calculType == 2
                                  ? _c(
                                      "div",
                                      { staticStyle: { "text-align": "left" } },
                                      [_vm._v(" 首重（KG） ")]
                                    )
                                  : _c(
                                      "div",
                                      { staticStyle: { "text-align": "left" } },
                                      [_vm._v("首件（个）")]
                                    ),
                              ]),
                            ],
                            2
                          ),
                          _c(
                            "el-table-column",
                            {
                              attrs: { prop: "freight", label: "运费（元）" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "text-align": "left",
                                            },
                                          },
                                          [_vm._v(_vm._s(scope.row.freight))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _c("template", { slot: "header" }, [
                                _c(
                                  "div",
                                  { staticStyle: { "text-align": "left" } },
                                  [_vm._v("运费（元）")]
                                ),
                              ]),
                            ],
                            2
                          ),
                          _c(
                            "el-table-column",
                            {
                              attrs: { prop: "addNum", label: "续件（个）" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "text-align": "left",
                                            },
                                          },
                                          [_vm._v(_vm._s(scope.row.addNum))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _c("template", { slot: "header" }, [
                                item.list && item.list[0].calculType == 2
                                  ? _c(
                                      "div",
                                      { staticStyle: { "text-align": "left" } },
                                      [_vm._v(" 续重（KG） ")]
                                    )
                                  : _c(
                                      "div",
                                      { staticStyle: { "text-align": "left" } },
                                      [_vm._v("续件（个）")]
                                    ),
                              ]),
                            ],
                            2
                          ),
                          _c(
                            "el-table-column",
                            {
                              attrs: { prop: "addPrice", label: "运费（元）" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "text-align": "left",
                                            },
                                          },
                                          [_vm._v(_vm._s(scope.row.addPrice))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _c("template", { slot: "header" }, [
                                _c(
                                  "div",
                                  { staticStyle: { "text-align": "left" } },
                                  [_vm._v("运费（元）")]
                                ),
                              ]),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }